// extracted by mini-css-extract-plugin
export default {"black":"#000","gray":"#444","error":"#cf6679","success":"#bbf09a","warning":"#ffca7f","labelGrayDark":"#aaa","compliance":"#c65900"};